import React, { useState } from 'react';
import { Modal, Form, Tooltip } from 'antd';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import { RefutarSlaFornecedor } from '@app/api/sla';

interface Props {
  id: string;
  UpdateGrid: () => any;
}

const ModalRefutarSlaFornecedor = (props: Props) => {
  const { id, UpdateGrid } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    RefutarSlaFornecedor({ medicaoId: id, justificativa: justificativa }).then(data => {
      if (data) {
        limparCampo();
        if (data.valid) {
          handleCancel();
          UpdateGrid();
        }
      }
    });
  };

  return (
    <>
      <Button
        type="danger"
        onClick={() => {
          showModal();
        }}>
        refutar
      </Button>

      <Modal
        title="Justificativa"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="primary" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
          <Button key="cancel" type="link" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <TextArea
          name="justificativa"
          id="justificativa"
          onChange={value => {
            setJustificativa(value.currentTarget.value);
          }}
          placeholder="informe a justificativa"
          rows={3}
        />
      </Modal>
    </>
  );
};

export default ModalRefutarSlaFornecedor;
